import { mergeLoaders } from "~/.server";
import { mergeComponents } from "~/utils";

export const loader = mergeLoaders({
  landing: () => import("./landing/.server"),
});

export default mergeComponents({
  landing: () => import("./landing/_page"),
});
